var ft = Object.defineProperty;
var je = (e) => {
  throw TypeError(e);
};
var gt = (e, t, s) => t in e ? ft(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s;
var k = (e, t, s) => gt(e, typeof t != "symbol" ? t + "" : t, s), we = (e, t, s) => t.has(e) || je("Cannot " + s);
var c = (e, t, s) => (we(e, t, "read from private field"), s ? s.call(e) : t.get(e)), j = (e, t, s) => t.has(e) ? je("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, s), b = (e, t, s, r) => (we(e, t, "write to private field"), r ? r.call(e, s) : t.set(e, s), s);
var J = (e, t, s, r) => ({
  set _(a) {
    b(e, t, a, s);
  },
  get _() {
    return c(e, t, r);
  }
});
import { a as ze, H as ue } from "./index.esm-9-TF9KQB.js";
import { R as mt, S as pt, f as xt, g as se, b as yt, u as he, h as fe, L as ge, O as He } from "./chunk-SYFQ2XB5-BF5IDYrB.js";
import { M as bt, u as V } from "./hook-BRQEDRbn.js";
import { E as Le, S as M, a as vt, R as jt } from "./SlotletProvider-_3zzX_g_.js";
import { j as n } from "./jsx-runtime-Bdg6XQ1m.js";
import { Button as wt } from "./ui/Button.js";
import { Callout as kt } from "./ui/Callout.js";
import { S as Ke, l as $e, Q as Ct, n as w, m as ke, o as Ce, p as D, q as Nt, r as Pt, t as St, v as Mt, w as Ne, x as Pe, y as Ot, h as Se, z as Me, A as Dt, e as At, B as Ze, C as Et, j as W, a as q, D as Ue, E as It, u as Qt, Z as Tt } from "./ZudokuContext-DeQZEp-x.js";
import * as $ from "react";
import qt, { StrictMode as Ve, useState as T, useEffect as R, useRef as me, useCallback as Rt, Suspense as pe, memo as We, forwardRef as Ft, createContext as _e, Component as Bt, createElement as Oe, useMemo as ne, useContext as zt, Fragment as Ht } from "react";
import * as Lt from "react-dom";
import { S as le } from "./StaggeredRender-DgsamH_G.js";
import { C as xe } from "./ClientOnly-E7hGysn1.js";
import { ChevronRightIcon as Kt, ExternalLinkIcon as $t, CircleXIcon as Zt, SearchIcon as Ut, MoonStarIcon as Vt, SunIcon as Wt, MenuIcon as _t, PanelLeftIcon as Xt } from "lucide-react";
import { Drawer as Xe, DrawerTrigger as Ye, DrawerContent as Je, DrawerTitle as Ge } from "./ui/Drawer.js";
import { c as O } from "./cn-qaFjX9_3.js";
import { u as ye, a as Yt, V as Jt, M as Gt } from "./Markdown-DFN6p0J-.js";
import { c as es, a as ts } from "./index-Djenk2Hj.js";
import { A as ss, M as ns, u as rs } from "./AnchorLink-bObQitZv.js";
import * as re from "@radix-ui/react-collapsible";
import { B as ce, S as et } from "./Spinner-BlzrEEk1.js";
import { DropdownMenu as as, DropdownMenuTrigger as is, DropdownMenuContent as os, DropdownMenuLabel as ls, DropdownMenuSeparator as ae, DropdownMenuSub as cs, DropdownMenuSubTrigger as ds, DropdownMenuPortal as us, DropdownMenuSubContent as hs, DropdownMenuItem as fs } from "./ui/DropdownMenu.js";
import { j as De } from "./joinUrl-BTy9bvoK.js";
import { VisuallyHidden as tt } from "@radix-ui/react-visually-hidden";
import { z as gs, J as ms } from "./SyntaxHighlight-CJCSPG1F.js";
import { Z as ps } from "./invariant-Caa8-XvF.js";
var S, Re, xs = (Re = class extends Ke {
  constructor(t = {}) {
    super();
    j(this, S);
    this.config = t, b(this, S, /* @__PURE__ */ new Map());
  }
  build(t, s, r) {
    const a = s.queryKey, i = s.queryHash ?? $e(a, s);
    let o = this.get(i);
    return o || (o = new Ct({
      cache: this,
      queryKey: a,
      queryHash: i,
      options: t.defaultQueryOptions(s),
      state: r,
      defaultOptions: t.getQueryDefaults(a)
    }), this.add(o)), o;
  }
  add(t) {
    c(this, S).has(t.queryHash) || (c(this, S).set(t.queryHash, t), this.notify({
      type: "added",
      query: t
    }));
  }
  remove(t) {
    const s = c(this, S).get(t.queryHash);
    s && (t.destroy(), s === t && c(this, S).delete(t.queryHash), this.notify({ type: "removed", query: t }));
  }
  clear() {
    w.batch(() => {
      this.getAll().forEach((t) => {
        this.remove(t);
      });
    });
  }
  get(t) {
    return c(this, S).get(t);
  }
  getAll() {
    return [...c(this, S).values()];
  }
  find(t) {
    const s = { exact: !0, ...t };
    return this.getAll().find(
      (r) => ke(s, r)
    );
  }
  findAll(t = {}) {
    const s = this.getAll();
    return Object.keys(t).length > 0 ? s.filter((r) => ke(t, r)) : s;
  }
  notify(t) {
    w.batch(() => {
      this.listeners.forEach((s) => {
        s(t);
      });
    });
  }
  onFocus() {
    w.batch(() => {
      this.getAll().forEach((t) => {
        t.onFocus();
      });
    });
  }
  onOnline() {
    w.batch(() => {
      this.getAll().forEach((t) => {
        t.onOnline();
      });
    });
  }
}, S = new WeakMap(), Re), A, N, _, Fe, ys = (Fe = class extends Ke {
  constructor(t = {}) {
    super();
    j(this, A);
    j(this, N);
    j(this, _);
    this.config = t, b(this, A, /* @__PURE__ */ new Set()), b(this, N, /* @__PURE__ */ new Map()), b(this, _, 0);
  }
  build(t, s, r) {
    const a = new bt({
      mutationCache: this,
      mutationId: ++J(this, _)._,
      options: t.defaultMutationOptions(s),
      state: r
    });
    return this.add(a), a;
  }
  add(t) {
    c(this, A).add(t);
    const s = G(t);
    if (typeof s == "string") {
      const r = c(this, N).get(s);
      r ? r.push(t) : c(this, N).set(s, [t]);
    }
    this.notify({ type: "added", mutation: t });
  }
  remove(t) {
    if (c(this, A).delete(t)) {
      const s = G(t);
      if (typeof s == "string") {
        const r = c(this, N).get(s);
        if (r)
          if (r.length > 1) {
            const a = r.indexOf(t);
            a !== -1 && r.splice(a, 1);
          } else r[0] === t && c(this, N).delete(s);
      }
    }
    this.notify({ type: "removed", mutation: t });
  }
  canRun(t) {
    const s = G(t);
    if (typeof s == "string") {
      const r = c(this, N).get(s), a = r == null ? void 0 : r.find(
        (i) => i.state.status === "pending"
      );
      return !a || a === t;
    } else
      return !0;
  }
  runNext(t) {
    var r;
    const s = G(t);
    if (typeof s == "string") {
      const a = (r = c(this, N).get(s)) == null ? void 0 : r.find((i) => i !== t && i.state.isPaused);
      return (a == null ? void 0 : a.continue()) ?? Promise.resolve();
    } else
      return Promise.resolve();
  }
  clear() {
    w.batch(() => {
      c(this, A).forEach((t) => {
        this.notify({ type: "removed", mutation: t });
      }), c(this, A).clear(), c(this, N).clear();
    });
  }
  getAll() {
    return Array.from(c(this, A));
  }
  find(t) {
    const s = { exact: !0, ...t };
    return this.getAll().find(
      (r) => Ce(s, r)
    );
  }
  findAll(t = {}) {
    return this.getAll().filter((s) => Ce(t, s));
  }
  notify(t) {
    w.batch(() => {
      this.listeners.forEach((s) => {
        s(t);
      });
    });
  }
  resumePausedMutations() {
    const t = this.getAll().filter((s) => s.state.isPaused);
    return w.batch(
      () => Promise.all(
        t.map((s) => s.continue().catch(D))
      )
    );
  }
}, A = new WeakMap(), N = new WeakMap(), _ = new WeakMap(), Fe);
function G(e) {
  var t;
  return (t = e.options.scope) == null ? void 0 : t.id;
}
function Ae(e) {
  return {
    onFetch: (t, s) => {
      var f, g, h, p, x;
      const r = t.options, a = (h = (g = (f = t.fetchOptions) == null ? void 0 : f.meta) == null ? void 0 : g.fetchMore) == null ? void 0 : h.direction, i = ((p = t.state.data) == null ? void 0 : p.pages) || [], o = ((x = t.state.data) == null ? void 0 : x.pageParams) || [];
      let d = { pages: [], pageParams: [] }, u = 0;
      const l = async () => {
        let m = !1;
        const C = (v) => {
          Object.defineProperty(v, "signal", {
            enumerable: !0,
            get: () => (t.signal.aborted ? m = !0 : t.signal.addEventListener("abort", () => {
              m = !0;
            }), t.signal)
          });
        }, X = Nt(t.options, t.fetchOptions), L = async (v, P, K) => {
          if (m)
            return Promise.reject();
          if (P == null && v.pages.length)
            return Promise.resolve(v);
          const Y = {
            queryKey: t.queryKey,
            pageParam: P,
            direction: K ? "backward" : "forward",
            meta: t.options.meta
          };
          C(Y);
          const ht = await X(
            Y
          ), { maxPages: be } = t.options, ve = K ? Pt : St;
          return {
            pages: ve(v.pages, ht, be),
            pageParams: ve(v.pageParams, P, be)
          };
        };
        if (a && i.length) {
          const v = a === "backward", P = v ? bs : Ee, K = {
            pages: i,
            pageParams: o
          }, Y = P(r, K);
          d = await L(K, Y, v);
        } else {
          const v = e ?? i.length;
          do {
            const P = u === 0 ? o[0] ?? r.initialPageParam : Ee(r, d);
            if (u > 0 && P == null)
              break;
            d = await L(d, P), u++;
          } while (u < v);
        }
        return d;
      };
      t.options.persister ? t.fetchFn = () => {
        var m, C;
        return (C = (m = t.options).persister) == null ? void 0 : C.call(
          m,
          l,
          {
            queryKey: t.queryKey,
            meta: t.options.meta,
            signal: t.signal
          },
          s
        );
      } : t.fetchFn = l;
    }
  };
}
function Ee(e, { pages: t, pageParams: s }) {
  const r = t.length - 1;
  return t.length > 0 ? e.getNextPageParam(
    t[r],
    t,
    s[r],
    s
  ) : void 0;
}
function bs(e, { pages: t, pageParams: s }) {
  var r;
  return t.length > 0 ? (r = e.getPreviousPageParam) == null ? void 0 : r.call(e, t[0], t, s[0], s) : void 0;
}
var y, E, I, F, B, Q, z, H, Be, vs = (Be = class {
  constructor(e = {}) {
    j(this, y);
    j(this, E);
    j(this, I);
    j(this, F);
    j(this, B);
    j(this, Q);
    j(this, z);
    j(this, H);
    b(this, y, e.queryCache || new xs()), b(this, E, e.mutationCache || new ys()), b(this, I, e.defaultOptions || {}), b(this, F, /* @__PURE__ */ new Map()), b(this, B, /* @__PURE__ */ new Map()), b(this, Q, 0);
  }
  mount() {
    J(this, Q)._++, c(this, Q) === 1 && (b(this, z, Mt.subscribe(async (e) => {
      e && (await this.resumePausedMutations(), c(this, y).onFocus());
    })), b(this, H, Ne.subscribe(async (e) => {
      e && (await this.resumePausedMutations(), c(this, y).onOnline());
    })));
  }
  unmount() {
    var e, t;
    J(this, Q)._--, c(this, Q) === 0 && ((e = c(this, z)) == null || e.call(this), b(this, z, void 0), (t = c(this, H)) == null || t.call(this), b(this, H, void 0));
  }
  isFetching(e) {
    return c(this, y).findAll({ ...e, fetchStatus: "fetching" }).length;
  }
  isMutating(e) {
    return c(this, E).findAll({ ...e, status: "pending" }).length;
  }
  getQueryData(e) {
    var s;
    const t = this.defaultQueryOptions({ queryKey: e });
    return (s = c(this, y).get(t.queryHash)) == null ? void 0 : s.state.data;
  }
  ensureQueryData(e) {
    const t = this.defaultQueryOptions(e), s = c(this, y).build(this, t), r = s.state.data;
    return r === void 0 ? this.fetchQuery(e) : (e.revalidateIfStale && s.isStaleByTime(Pe(t.staleTime, s)) && this.prefetchQuery(t), Promise.resolve(r));
  }
  getQueriesData(e) {
    return c(this, y).findAll(e).map(({ queryKey: t, state: s }) => {
      const r = s.data;
      return [t, r];
    });
  }
  setQueryData(e, t, s) {
    const r = this.defaultQueryOptions({ queryKey: e }), a = c(this, y).get(
      r.queryHash
    ), i = a == null ? void 0 : a.state.data, o = Ot(t, i);
    if (o !== void 0)
      return c(this, y).build(this, r).setData(o, { ...s, manual: !0 });
  }
  setQueriesData(e, t, s) {
    return w.batch(
      () => c(this, y).findAll(e).map(({ queryKey: r }) => [
        r,
        this.setQueryData(r, t, s)
      ])
    );
  }
  getQueryState(e) {
    var s;
    const t = this.defaultQueryOptions({ queryKey: e });
    return (s = c(this, y).get(
      t.queryHash
    )) == null ? void 0 : s.state;
  }
  removeQueries(e) {
    const t = c(this, y);
    w.batch(() => {
      t.findAll(e).forEach((s) => {
        t.remove(s);
      });
    });
  }
  resetQueries(e, t) {
    const s = c(this, y), r = {
      type: "active",
      ...e
    };
    return w.batch(() => (s.findAll(e).forEach((a) => {
      a.reset();
    }), this.refetchQueries(r, t)));
  }
  cancelQueries(e, t = {}) {
    const s = { revert: !0, ...t }, r = w.batch(
      () => c(this, y).findAll(e).map((a) => a.cancel(s))
    );
    return Promise.all(r).then(D).catch(D);
  }
  invalidateQueries(e, t = {}) {
    return w.batch(() => {
      if (c(this, y).findAll(e).forEach((r) => {
        r.invalidate();
      }), (e == null ? void 0 : e.refetchType) === "none")
        return Promise.resolve();
      const s = {
        ...e,
        type: (e == null ? void 0 : e.refetchType) ?? (e == null ? void 0 : e.type) ?? "active"
      };
      return this.refetchQueries(s, t);
    });
  }
  refetchQueries(e, t = {}) {
    const s = {
      ...t,
      cancelRefetch: t.cancelRefetch ?? !0
    }, r = w.batch(
      () => c(this, y).findAll(e).filter((a) => !a.isDisabled()).map((a) => {
        let i = a.fetch(void 0, s);
        return s.throwOnError || (i = i.catch(D)), a.state.fetchStatus === "paused" ? Promise.resolve() : i;
      })
    );
    return Promise.all(r).then(D);
  }
  fetchQuery(e) {
    const t = this.defaultQueryOptions(e);
    t.retry === void 0 && (t.retry = !1);
    const s = c(this, y).build(this, t);
    return s.isStaleByTime(
      Pe(t.staleTime, s)
    ) ? s.fetch(t) : Promise.resolve(s.state.data);
  }
  prefetchQuery(e) {
    return this.fetchQuery(e).then(D).catch(D);
  }
  fetchInfiniteQuery(e) {
    return e.behavior = Ae(e.pages), this.fetchQuery(e);
  }
  prefetchInfiniteQuery(e) {
    return this.fetchInfiniteQuery(e).then(D).catch(D);
  }
  ensureInfiniteQueryData(e) {
    return e.behavior = Ae(e.pages), this.ensureQueryData(e);
  }
  resumePausedMutations() {
    return Ne.isOnline() ? c(this, E).resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return c(this, y);
  }
  getMutationCache() {
    return c(this, E);
  }
  getDefaultOptions() {
    return c(this, I);
  }
  setDefaultOptions(e) {
    b(this, I, e);
  }
  setQueryDefaults(e, t) {
    c(this, F).set(Se(e), {
      queryKey: e,
      defaultOptions: t
    });
  }
  getQueryDefaults(e) {
    const t = [...c(this, F).values()], s = {};
    return t.forEach((r) => {
      Me(e, r.queryKey) && Object.assign(s, r.defaultOptions);
    }), s;
  }
  setMutationDefaults(e, t) {
    c(this, B).set(Se(e), {
      mutationKey: e,
      defaultOptions: t
    });
  }
  getMutationDefaults(e) {
    const t = [...c(this, B).values()];
    let s = {};
    return t.forEach((r) => {
      Me(e, r.mutationKey) && (s = { ...s, ...r.defaultOptions });
    }), s;
  }
  defaultQueryOptions(e) {
    if (e._defaulted)
      return e;
    const t = {
      ...c(this, I).queries,
      ...this.getQueryDefaults(e.queryKey),
      ...e,
      _defaulted: !0
    };
    return t.queryHash || (t.queryHash = $e(
      t.queryKey,
      t
    )), t.refetchOnReconnect === void 0 && (t.refetchOnReconnect = t.networkMode !== "always"), t.throwOnError === void 0 && (t.throwOnError = !!t.suspense), !t.networkMode && t.persister && (t.networkMode = "offlineFirst"), t.queryFn === Dt && (t.enabled = !1), t;
  }
  defaultMutationOptions(e) {
    return e != null && e._defaulted ? e : {
      ...c(this, I).mutations,
      ...(e == null ? void 0 : e.mutationKey) && this.getMutationDefaults(e.mutationKey),
      ...e,
      _defaulted: !0
    };
  }
  clear() {
    c(this, y).clear(), c(this, E).clear();
  }
}, y = new WeakMap(), E = new WeakMap(), I = new WeakMap(), F = new WeakMap(), B = new WeakMap(), Q = new WeakMap(), z = new WeakMap(), H = new WeakMap(), Be);
function js(e) {
  return e;
}
function Ie(e, t, s) {
  var u, l;
  if (typeof t != "object" || t === null)
    return;
  const r = e.getMutationCache(), a = e.getQueryCache(), i = ((u = s == null ? void 0 : s.defaultOptions) == null ? void 0 : u.deserializeData) ?? ((l = e.getDefaultOptions().hydrate) == null ? void 0 : l.deserializeData) ?? js, o = t.mutations || [], d = t.queries || [];
  o.forEach(({ state: f, ...g }) => {
    var h, p;
    r.build(
      e,
      {
        ...(h = e.getDefaultOptions().hydrate) == null ? void 0 : h.mutations,
        ...(p = s == null ? void 0 : s.defaultOptions) == null ? void 0 : p.mutations,
        ...g
      },
      f
    );
  }), d.forEach(({ queryKey: f, state: g, queryHash: h, meta: p, promise: x }) => {
    var X, L;
    let m = a.get(h);
    const C = g.data === void 0 ? g.data : i(g.data);
    if (m) {
      if (m.state.dataUpdatedAt < g.dataUpdatedAt) {
        const { fetchStatus: v, ...P } = g;
        m.setState({
          ...P,
          data: C
        });
      }
    } else
      m = a.build(
        e,
        {
          ...(X = e.getDefaultOptions().hydrate) == null ? void 0 : X.queries,
          ...(L = s == null ? void 0 : s.defaultOptions) == null ? void 0 : L.queries,
          queryKey: f,
          queryHash: h,
          meta: p
        },
        // Reset fetch status to idle to avoid
        // query being stuck in fetching state upon hydration
        {
          ...g,
          data: C,
          fetchStatus: "idle"
        }
      );
    if (x) {
      const v = Promise.resolve(x).then(i);
      m.fetch(void 0, { initialPromise: v });
    }
  });
}
var ws = ({
  children: e,
  options: t = {},
  state: s,
  queryClient: r
}) => {
  const a = At(r), [i, o] = $.useState(), d = $.useRef(t);
  return d.current = t, $.useMemo(() => {
    if (s) {
      if (typeof s != "object")
        return;
      const u = a.getQueryCache(), l = s.queries || [], f = [], g = [];
      for (const h of l) {
        const p = u.get(h.queryHash);
        if (!p)
          f.push(h);
        else {
          const x = h.state.dataUpdatedAt > p.state.dataUpdatedAt, m = i == null ? void 0 : i.find(
            (C) => C.queryHash === h.queryHash
          );
          x && (!m || h.state.dataUpdatedAt > m.state.dataUpdatedAt) && g.push(h);
        }
      }
      f.length > 0 && Ie(a, { queries: f }, d.current), g.length > 0 && o(
        (h) => h ? [...h, ...g] : g
      );
    }
  }, [a, i, s]), $.useEffect(() => {
    i && (Ie(a, { queries: i }, d.current), o(void 0));
  }, [a, i]), e;
};
function ks({ error: e }) {
  return /* @__PURE__ */ n.jsx(Le, { error: e });
}
/**
 * react-router v7.1.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Cs(e) {
  return /* @__PURE__ */ $.createElement(mt, { flushSync: Lt.flushSync, ...e });
}
const Ns = new vs({
  defaultOptions: {
    queries: {
      staleTime: 1e3 * 60 * 5
    }
  }
}), Ps = ({
  router: e,
  hydrate: t = !1
}) => /* @__PURE__ */ n.jsx(Ve, { children: /* @__PURE__ */ n.jsx(Ze, { client: Ns, children: /* @__PURE__ */ n.jsx(ws, { state: t ? window.DATA : void 0, children: /* @__PURE__ */ n.jsx(ze, { children: /* @__PURE__ */ n.jsx(le.Provider, { value: { stagger: !t }, children: /* @__PURE__ */ n.jsx(Cs, { router: e }) }) }) }) }) }), Ss = ({
  router: e,
  context: t,
  queryClient: s,
  helmetContext: r
}) => /* @__PURE__ */ n.jsx(Ve, { children: /* @__PURE__ */ n.jsx(Ze, { client: s, children: /* @__PURE__ */ n.jsx(ze, { context: r, children: /* @__PURE__ */ n.jsx(pt, { router: e, context: t }) }) }) });
var Z = { exports: {} }, Ms = Z.exports, Qe;
function Os() {
  return Qe || (Qe = 1, function(e, t) {
    (function(s, r) {
      r(t, qt);
    })(Ms, function(s, r) {
      const a = {
        delay: 500,
        minDuration: 200,
        ssr: !0
      };
      function i() {
        const [d, u] = r.useState(!0);
        return r.useEffect(() => {
          u(!1);
        }, []), d;
      }
      function o(d, u) {
        u = Object.assign({}, a, u);
        const l = i() && u.ssr, f = l && d ? "DISPLAY" : "IDLE", [g, h] = r.useState(f), p = r.useRef(null);
        return r.useEffect(() => {
          if (d && (g === "IDLE" || l)) {
            clearTimeout(p.current);
            const x = l ? 0 : u.delay;
            p.current = setTimeout(() => {
              if (!d)
                return h("IDLE");
              p.current = setTimeout(() => {
                h("EXPIRE");
              }, u.minDuration), h("DISPLAY");
            }, x), l || h("DELAY");
          }
          !d && g !== "DISPLAY" && (clearTimeout(p.current), h("IDLE"));
        }, [d, g, u.delay, u.minDuration, l]), r.useEffect(() => () => clearTimeout(p.current), []), g === "DISPLAY" || g === "EXPIRE";
      }
      s.defaultOptions = a, s.useSpinDelay = o;
    });
  }(Z, Z.exports)), Z.exports;
}
var Ds = Os();
const As = {
  green: "bg-green-400 dark:bg-green-800",
  blue: "bg-sky-400 dark:bg-sky-800",
  yellow: "bg-yellow-400 dark:bg-yellow-800",
  red: "bg-red-400 dark:bg-red-800",
  purple: "bg-purple-400 dark:bg-purple-600",
  indigo: "bg-indigo-400 dark:bg-indigo-600",
  gray: "bg-gray-400 dark:bg-gray-600"
}, Es = {
  green: "text-green-500 dark:text-green-600",
  blue: "text-sky-400 dark:text-sky-600",
  yellow: "text-yellow-400 dark:text-yellow-600",
  red: "text-red-400 dark:text-red-600",
  purple: "text-purple-400 dark:text-purple-600",
  indigo: "text-indigo-400 dark:text-indigo-600",
  gray: "text-gray-400 dark:text-gray-600"
}, ie = ({
  color: e,
  label: t,
  className: s,
  invert: r
}) => /* @__PURE__ */ n.jsx(
  "span",
  {
    className: O(
      "mt-0.5 flex items-center duration-200 transition-opacity text-center uppercase font-mono text-[0.65rem] font-bold rounded text-background dark:text-zinc-50 h-4 px-1",
      r ? Es[e] : As[e],
      s
    ),
    children: t
  }
), Is = ({
  category: e,
  onRequestClose: t
}) => {
  var h, p;
  const s = Et(e), [r, a] = T(!1), i = e.collapsible ?? !0, o = e.collapsed ?? !0, d = !!(!i || !o || s), [u, l] = T(d), f = xt(((h = e.link) == null ? void 0 : h.id) ?? "");
  R(() => {
    s && l(!0);
  }, [s]);
  const g = i && /* @__PURE__ */ n.jsx(
    "button",
    {
      type: "button",
      onClick: (x) => {
        x.preventDefault(), l((m) => !m), a(!0);
      },
      children: /* @__PURE__ */ n.jsx(
        Kt,
        {
          size: 16,
          className: O(
            r && "transition",
            "shrink-0 group-data-[state=open]:rotate-90"
          )
        }
      )
    }
  );
  return /* @__PURE__ */ n.jsxs(
    re.Root,
    {
      className: "flex flex-col",
      defaultOpen: d,
      open: u,
      onOpenChange: () => l(!0),
      children: [
        /* @__PURE__ */ n.jsx(re.Trigger, { className: "group", asChild: !0, disabled: !i, children: /* @__PURE__ */ n.jsxs(
          "div",
          {
            onClick: () => a(!0),
            className: U({
              isActive: !1,
              className: [
                "text-start font-medium",
                i ? "cursor-pointer" : "cursor-default hover:bg-transparent"
              ]
            }),
            children: [
              e.icon && /* @__PURE__ */ n.jsx(
                e.icon,
                {
                  size: 16,
                  className: O("align-[-0.125em] ", f && "text-primary")
                }
              ),
              ((p = e.link) == null ? void 0 : p.type) === "doc" ? /* @__PURE__ */ n.jsx(
                se,
                {
                  to: W(e.link.id),
                  className: "flex-1",
                  onClick: () => {
                    f && !u && l(!0);
                  },
                  children: /* @__PURE__ */ n.jsxs(
                    "div",
                    {
                      className: O(
                        "flex items-center gap-2 justify-between w-full",
                        f ? "text-primary" : "text-foreground/80"
                      ),
                      children: [
                        /* @__PURE__ */ n.jsx("div", { className: "truncate", children: e.label }),
                        g
                      ]
                    }
                  )
                }
              ) : /* @__PURE__ */ n.jsxs("div", { className: "flex items-center justify-between w-full", children: [
                /* @__PURE__ */ n.jsx("div", { className: "flex gap-2 truncate w-full", children: e.label }),
                g
              ] })
            ]
          }
        ) }),
        /* @__PURE__ */ n.jsx(
          re.Content,
          {
            className: O(
              // CollapsibleContent class is used to animate and it should only be applied when the user has triggered the toggle
              r && "CollapsibleContent",
              "ms-6 my-1"
            ),
            children: /* @__PURE__ */ n.jsx("ul", { className: "relative after:absolute after:-left-[--padding-nav-item] after:translate-x-[1.5px] after:top-0 after:bottom-0 after:w-px after:bg-border", children: e.items.map((x) => /* @__PURE__ */ n.jsx(
              de,
              {
                onRequestClose: t,
                item: x
              },
              ("id" in x ? x.id : "") + ("href" in x ? x.href : "") + x.label
            )) })
          }
        )
      ]
    }
  );
}, U = es(
  "flex items-center gap-2 px-[--padding-nav-item] py-1.5 rounded-lg hover:bg-accent",
  {
    variants: {
      isActive: {
        true: "text-primary font-medium",
        false: "text-foreground/80"
      },
      isMuted: {
        true: "text-foreground/30",
        false: ""
      }
    },
    defaultVariants: {
      isActive: !1
    }
  }
), st = "data-anchor", de = ({
  item: e,
  onRequestClose: t
}) => {
  var a, i;
  const { activeAnchor: s } = ye(), [r] = yt();
  switch (e.type) {
    case "category":
      return /* @__PURE__ */ n.jsx(Is, { category: e, onRequestClose: t });
    case "doc":
      return /* @__PURE__ */ n.jsxs(
        se,
        {
          className: ({ isActive: o }) => U({ isActive: o }),
          to: W(e.id),
          onClick: t,
          children: [
            e.icon && /* @__PURE__ */ n.jsx(e.icon, { size: 16, className: "align-[-0.125em]" }),
            e.badge ? /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
              /* @__PURE__ */ n.jsx("span", { className: "truncate flex-1", title: e.label, children: e.label }),
              /* @__PURE__ */ n.jsx(ie, { ...e.badge })
            ] }) : e.label
          ]
        }
      );
    case "link":
      return e.href.startsWith("#") ? /* @__PURE__ */ n.jsx(
        ss,
        {
          to: { hash: e.href, search: r.toString() },
          [st]: e.href.slice(1),
          className: U({
            isActive: e.href.slice(1) === s,
            className: ((a = e.badge) == null ? void 0 : a.placement) !== "start" && "justify-between"
          }),
          onClick: t,
          children: e.badge ? /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
            /* @__PURE__ */ n.jsx("span", { className: "truncate", title: e.label, children: e.label }),
            /* @__PURE__ */ n.jsx(ie, { ...e.badge })
          ] }) : /* @__PURE__ */ n.jsx("span", { className: "break-all", children: e.label })
        }
      ) : e.href.startsWith("http") ? /* @__PURE__ */ n.jsxs(
        "a",
        {
          className: U(),
          href: e.href,
          target: "_blank",
          rel: "noopener noreferrer",
          onClick: t,
          children: [
            /* @__PURE__ */ n.jsx("span", { className: "whitespace-normal", children: e.label }),
            /* @__PURE__ */ n.jsx("span", { className: "whitespace-nowrap", children: /* @__PURE__ */ n.jsx($t, { className: "inline -translate-y-0.5", size: 12 }) })
          ]
        }
      ) : /* @__PURE__ */ n.jsx(
        se,
        {
          className: U({
            className: ((i = e.badge) == null ? void 0 : i.placement) !== "start" && "justify-between"
          }),
          to: e.href,
          children: e.badge ? /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
            /* @__PURE__ */ n.jsx("span", { className: "truncate", title: e.label, children: e.label }),
            /* @__PURE__ */ n.jsx(ie, { ...e.badge })
          ] }) : /* @__PURE__ */ n.jsx("span", { className: "break-all", children: e.label })
        }
      );
  }
}, Qs = (e, t = { block: "center" }) => {
  if (!e) return;
  const s = e.getBoundingClientRect();
  s.top >= 0 && s.left >= 0 && s.bottom <= (window.innerHeight || document.documentElement.clientHeight) && s.right <= (window.innerWidth || document.documentElement.clientWidth) || e.scrollIntoView(t);
}, Ts = () => {
  const e = he(), { setActiveAnchor: t } = ye();
  R(() => {
    if (!e.hash) return;
    const s = decodeURIComponent(e.hash.split("/")[0].slice(1)), r = () => {
      const a = document.getElementById(s), i = document.querySelector(`[${st}="${s}"]`);
      return a ? (a.scrollIntoView(), Qs(i), requestIdleCallback(() => t(s)), !0) : !1;
    };
    if (!r()) {
      const a = new MutationObserver((i, o) => {
        r() && o.disconnect();
      });
      return a.observe(document.body, { childList: !0, subtree: !0 }), () => a.disconnect();
    }
  }, [e.hash, t]);
}, qs = () => {
  const e = he(), t = me(e.pathname);
  R(() => {
    t.current !== e.pathname && (window.scrollTo(0, 0), t.current = e.pathname);
  }, [e.pathname]);
};
function Rs({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ n.jsx(
    "div",
    {
      className: O("animate-pulse rounded-md bg-muted", e),
      ...t
    }
  );
}
const Fs = (e) => "getProfileMenuItems" in e && typeof e.getProfileMenuItems == "function", Bs = (e) => "getRoutes" in e && typeof e.getRoutes == "function", zs = (e) => "renderSearch" in e && typeof e.renderSearch == "function", Hs = (e) => "initialize" in e && typeof e.initialize == "function", Ls = (e) => "getHead" in e && typeof e.getHead == "function", Ks = (e) => "getMdxComponents" in e && typeof e.getMdxComponents == "function", $s = (e) => "getIdentities" in e && typeof e.getIdentities == "function", Te = {
  info: "bg-blue-500",
  note: "bg-gray-500",
  tip: "bg-green-600",
  caution: "bg-orange-500",
  danger: "bg-rose-500"
}, Zs = () => {
  const { page: e } = q(), [t, s] = T(!0);
  if (!(e != null && e.banner) || !t)
    return /* @__PURE__ */ n.jsx("style", { children: ":root { --banner-height: 0px; }" });
  const r = e.banner.color && e.banner.color in Te ? Te[e.banner.color] : e.banner.color ? void 0 : "bg-primary", a = r ? {} : { backgroundColor: e.banner.color };
  return /* @__PURE__ */ n.jsxs(
    "div",
    {
      className: O(
        "relative text-primary-foreground text-sm font-medium px-4 py-2 flex gap-2 items-center",
        r
      ),
      style: a,
      children: [
        /* @__PURE__ */ n.jsx("div", { className: "w-full", children: e.banner.message }),
        e.banner.dismissible && /* @__PURE__ */ n.jsx(
          "button",
          {
            type: "button",
            className: "md:absolute md:right-4 -m-1.5 p-1.5 hover:bg-accent-foreground/10 rounded-md",
            onClick: () => s(!1),
            children: /* @__PURE__ */ n.jsx(Zt, { size: 16 })
          }
        )
      ]
    }
  );
}, nt = ({ className: e }) => {
  const t = q(), [s, r] = T(!1), a = Rt(() => r(!1), []);
  R(() => {
    if (s)
      return;
    function o(d) {
      d.key === "k" && (d.metaKey || d.ctrlKey) && (d.preventDefault(), r(!0));
    }
    return window.addEventListener("keydown", o), () => {
      window.removeEventListener("keydown", o);
    };
  }, [s, r]);
  const i = t.plugins.find(zs);
  return i ? /* @__PURE__ */ n.jsxs("div", { className: e, children: [
    /* @__PURE__ */ n.jsxs(
      "button",
      {
        type: "button",
        onClick: () => r(!0),
        className: "flex items-center border border-input hover:bg-accent hover:text-accent-foreground p-4 relative h-8 justify-start rounded-lg bg-background text-sm text-muted-foreground shadow-none w-full sm:w-72",
        children: [
          /* @__PURE__ */ n.jsxs("div", { className: "flex items-center gap-2 flex-grow", children: [
            /* @__PURE__ */ n.jsx(Ut, { size: 14 }),
            "Search"
          ] }),
          /* @__PURE__ */ n.jsx("kbd", { className: "absolute right-[0.3rem] top-[0.3rem] hidden h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[11px] font-medium opacity-100 sm:flex", children: "⌘K" })
        ]
      }
    ),
    /* @__PURE__ */ n.jsx(pe, { fallback: null, children: i.renderSearch({
      isOpen: s,
      onClose: a
    }) })
  ] }) : null;
}, rt = () => {
  const { resolvedTheme: e, setTheme: t } = gs(), s = e === "dark" ? Vt : Wt;
  return /* @__PURE__ */ n.jsx(xe, { children: /* @__PURE__ */ n.jsx(
    ce,
    {
      variant: "ghost",
      "aria-label": e === "dark" ? "Switch to light mode" : "Switch to dark mode",
      className: "p-2.5 -m-2.5 rounded-full",
      onClick: () => t(e === "dark" ? "light" : "dark"),
      children: /* @__PURE__ */ n.jsx(s, { size: 18 })
    }
  ) });
}, at = (e) => (t) => t.display === "auth" && e || t.display === "anon" && !e || !t.display || t.display === "always", Us = () => {
  const { topNavigation: e } = q(), { isAuthenticated: t } = V();
  return e.length <= 1 ? /* @__PURE__ */ n.jsx("style", { children: ":root { --top-nav-height: 0px; }" }) : /* @__PURE__ */ n.jsx(pe, { children: /* @__PURE__ */ n.jsx("nav", { className: "hidden lg:block text-sm px-12 h-[--top-nav-height]", children: /* @__PURE__ */ n.jsx("ul", { className: "flex flex-row items-center gap-8", children: e.filter(at(t)).map((s) => /* @__PURE__ */ n.jsx("li", { children: /* @__PURE__ */ n.jsx(it, { ...s }) }, s.id)) }) }) });
}, it = ({
  id: e,
  label: t,
  default: s
}) => {
  var l;
  const { sidebars: r } = q(), a = r[e], i = Ue(), o = !!fe().location, d = ((l = i.topNavItem) == null ? void 0 : l.id) === e && !o, u = s ?? (a ? It(a, (f) => {
    if (f.type === "doc") return W(f.id);
  }) : W(e));
  if (!u)
    throw new ps("Page not found.", {
      developerHint: `No links found in top navigation for '${e}'. Check that the sidebar isn't empty or that a default link is set.`
    });
  return (
    // We don't use isActive here because it has to be inside the sidebar,
    // the top nav id doesn't necessarily start with the sidebar id
    /* @__PURE__ */ n.jsx(
      se,
      {
        className: ({ isPending: f }) => ts(
          "block lg:py-3.5 font-medium -mb-px",
          d || f ? "border-primary text-foreground" : "border-transparent text-foreground/75 hover:text-foreground hover:border-accent-foreground/25"
        ),
        to: u,
        children: t
      }
    )
  );
}, Vs = () => {
  const { topNavigation: e } = q(), { isAuthenticated: t } = V(), [s, r] = T(!1);
  return /* @__PURE__ */ n.jsxs(
    Xe,
    {
      direction: "right",
      open: s,
      onOpenChange: (a) => r(a),
      children: [
        /* @__PURE__ */ n.jsx("div", { className: "flex lg:hidden justify-self-end", children: /* @__PURE__ */ n.jsx(Ye, { className: "lg:hidden", children: /* @__PURE__ */ n.jsx(_t, { size: 22 }) }) }),
        /* @__PURE__ */ n.jsx(
          Je,
          {
            className: "lg:hidden h-[100dvh] right-0 left-auto w-[320px] rounded-none",
            "aria-describedby": void 0,
            children: /* @__PURE__ */ n.jsxs("div", { className: "p-4 overflow-y-auto overscroll-none", children: [
              /* @__PURE__ */ n.jsx(tt, { children: /* @__PURE__ */ n.jsx(Ge, { children: "Navigation" }) }),
              /* @__PURE__ */ n.jsx(nt, { className: "flex p-4" }),
              /* @__PURE__ */ n.jsxs("ul", { className: "flex flex-col items-center gap-4 p-4", children: [
                /* @__PURE__ */ n.jsx("li", { children: /* @__PURE__ */ n.jsx(rt, {}) }),
                e.filter(at(t)).map((a) => /* @__PURE__ */ n.jsx("li", { children: /* @__PURE__ */ n.jsx("button", { onClick: () => r(!1), children: /* @__PURE__ */ n.jsx(it, { ...a }) }) }, a.label))
              ] })
            ] })
          }
        )
      ]
    }
  );
}, te = ({ item: e }) => e.children ? /* @__PURE__ */ n.jsxs(cs, { children: [
  /* @__PURE__ */ n.jsx(ds, { children: e.label }),
  /* @__PURE__ */ n.jsx(us, { children: /* @__PURE__ */ n.jsx(hs, { children: e.children.map((t, s) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ n.jsx(te, { item: t }, s)
  )) }) })
] }, e.label) : /* @__PURE__ */ n.jsx(ge, { to: e.path ?? "", children: /* @__PURE__ */ n.jsxs(fs, { className: "flex gap-2", children: [
  e.icon && /* @__PURE__ */ n.jsx(e.icon, { size: 16, strokeWidth: 1, absoluteStrokeWidth: !0 }),
  e.label
] }, e.label) }), ot = We(function() {
  const t = V(), { isAuthenticated: s, profile: r, isAuthEnabled: a } = V(), i = q(), { page: o, plugins: d } = i, u = d.filter((l) => Fs(l)).flatMap((l) => l.getProfileMenuItems(i)).sort((l) => l.weight ?? 0);
  return /* @__PURE__ */ n.jsxs("header", { className: "sticky lg:top-0 z-10 bg-background/80 backdrop-blur w-full", children: [
    /* @__PURE__ */ n.jsx(Zs, {}),
    /* @__PURE__ */ n.jsx("div", { className: "border-b", children: /* @__PURE__ */ n.jsxs("div", { className: "max-w-screen-2xl border-l border-r mx-auto grid grid-cols-[1fr_auto] lg:grid-cols-[calc(var(--side-nav-width))_1fr] lg:gap-12 items-center px-4 lg:px-12 h-[--top-header-height]", children: [
      /* @__PURE__ */ n.jsx("div", { className: "flex", children: /* @__PURE__ */ n.jsx(ge, { to: "/", children: /* @__PURE__ */ n.jsxs("div", { className: "flex items-center gap-3.5", children: [
        (o == null ? void 0 : o.logo) && /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
          /* @__PURE__ */ n.jsx(
            "img",
            {
              src: /https?:\/\//.test(o.logo.src.light) ? o.logo.src.light : De(
                "/",
                o.logo.src.light
              ),
              alt: o.logo.alt ?? o.pageTitle,
              style: { width: o.logo.width },
              className: "h-10 dark:hidden",
              loading: "lazy"
            }
          ),
          /* @__PURE__ */ n.jsx(
            "img",
            {
              src: /https?:\/\//.test(o.logo.src.dark) ? o.logo.src.dark : De(
                "/",
                o.logo.src.dark
              ),
              alt: o.logo.alt ?? o.pageTitle,
              style: { width: o.logo.width },
              className: "h-10 hidden dark:block",
              loading: "lazy"
            }
          )
        ] }),
        /* @__PURE__ */ n.jsx("span", { className: "font-bold text-2xl text-foreground/85 tracking-wide", children: o == null ? void 0 : o.pageTitle })
      ] }) }) }),
      /* @__PURE__ */ n.jsxs("div", { className: "grid grid-cols-1 lg:grid-cols-[--sidecar-grid-cols] items-center gap-8", children: [
        /* @__PURE__ */ n.jsx("div", { className: "w-full justify-center hidden lg:flex", children: /* @__PURE__ */ n.jsx(nt, {}) }),
        /* @__PURE__ */ n.jsx(Vs, {}),
        /* @__PURE__ */ n.jsxs("div", { className: "hidden lg:flex items-center justify-self-end text-sm gap-2", children: [
          /* @__PURE__ */ n.jsx(M, { name: "head-navigation-start" }),
          a && /* @__PURE__ */ n.jsx(
            xe,
            {
              fallback: /* @__PURE__ */ n.jsx(Rs, { className: "rounded h-5 w-24 mr-4" }),
              children: s ? Object.values(u).length > 0 && /* @__PURE__ */ n.jsxs(as, { modal: !1, children: [
                /* @__PURE__ */ n.jsx(is, { asChild: !0, children: /* @__PURE__ */ n.jsx(ce, { variant: "ghost", children: r != null && r.name ? `${r.name}` : "My Account" }) }),
                /* @__PURE__ */ n.jsxs(os, { className: "w-56", children: [
                  /* @__PURE__ */ n.jsxs(ls, { children: [
                    r != null && r.name ? `${r.name}` : "My Account",
                    (r == null ? void 0 : r.email) && /* @__PURE__ */ n.jsx("div", { className: "font-normal text-muted-foreground", children: r.email })
                  ] }),
                  u.filter((l) => l.category === "top").length > 0 && /* @__PURE__ */ n.jsx(ae, {}),
                  u.filter((l) => l.category === "top").map((l) => /* @__PURE__ */ n.jsx(te, { item: l }, l.label)),
                  u.filter(
                    (l) => !l.category || l.category === "middle"
                  ).length > 0 && /* @__PURE__ */ n.jsx(ae, {}),
                  u.filter(
                    (l) => !l.category || l.category === "middle"
                  ).map((l) => /* @__PURE__ */ n.jsx(te, { item: l }, l.label)),
                  u.filter((l) => l.category === "bottom").length > 0 && /* @__PURE__ */ n.jsx(ae, {}),
                  u.filter((l) => l.category === "bottom").map((l) => /* @__PURE__ */ n.jsx(te, { item: l }, l.label))
                ] })
              ] }) : /* @__PURE__ */ n.jsx(ce, { variant: "ghost", onClick: () => t.login(), children: "Login" })
            }
          ),
          /* @__PURE__ */ n.jsx(rt, {}),
          /* @__PURE__ */ n.jsx(M, { name: "head-navigation-end" })
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ n.jsx("div", { className: "border-b", children: /* @__PURE__ */ n.jsxs("div", { className: "max-w-screen-2xl mx-auto border-l border-r", children: [
      /* @__PURE__ */ n.jsx(M, { name: "top-navigation-before" }),
      /* @__PURE__ */ n.jsx(Us, {}),
      /* @__PURE__ */ n.jsx(M, { name: "top-navigation-after" })
    ] }) })
  ] });
}), lt = Ft(({ children: e, className: t, pushMainContent: s }, r) => /* @__PURE__ */ n.jsx(
  "nav",
  {
    "data-navigation": String(s),
    className: O(
      "scrollbar peer hidden lg:flex flex-col fixed text-sm overflow-y-auto shrink-0 border-r pr-10",
      "-mx-[--padding-nav-item] pb-20 pt-[--padding-content-top]",
      "w-[--side-nav-width] h-[calc(100%-var(--header-height))] scroll-pt-2 gap-2",
      !s && "border-r-0",
      t
    ),
    ref: r,
    children: e
  }
));
lt.displayName = "SidebarWrapper";
const Ws = ({
  onRequestClose: e
}) => {
  const t = me(null), s = Ue();
  return /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
    /* @__PURE__ */ n.jsxs(
      lt,
      {
        ref: t,
        pushMainContent: s.sidebar.length > 0,
        children: [
          /* @__PURE__ */ n.jsx(M, { name: "zudoku-before-navigation" }),
          s.sidebar.map((r) => /* @__PURE__ */ n.jsx(de, { item: r }, r.label)),
          /* @__PURE__ */ n.jsx(M, { name: "zudoku-after-navigation" })
        ]
      }
    ),
    /* @__PURE__ */ n.jsx(
      Je,
      {
        className: "lg:hidden h-[100dvh] left-0 w-[320px] rounded-none",
        "aria-describedby": void 0,
        children: /* @__PURE__ */ n.jsxs("div", { className: "p-4 overflow-y-auto overscroll-none", children: [
          /* @__PURE__ */ n.jsx(tt, { children: /* @__PURE__ */ n.jsx(Ge, { children: "Sidebar" }) }),
          s.sidebar.map((r) => /* @__PURE__ */ n.jsx(
            de,
            {
              item: r,
              onRequestClose: e
            },
            r.label
          ))
        ] })
      }
    )
  ] });
}, qe = () => /* @__PURE__ */ n.jsx("main", { className: "grid h-[calc(100vh-var(--header-height))] place-items-center", children: /* @__PURE__ */ n.jsx(et, {}) }), _s = ({ children: e }) => {
  const t = he(), { setActiveAnchor: s } = ye(), { meta: r, authentication: a } = q();
  Ts(), qs();
  const i = me(t.pathname);
  R(() => {
    var f;
    (f = a == null ? void 0 : a.onPageLoad) == null || f.call(a);
  }, [a]), R(() => {
    t.pathname !== i.current && s(""), i.current = t.pathname;
  }, [t.pathname, s]);
  const o = !!fe().location, d = Ds.useSpinDelay(o, {
    delay: 300,
    minDuration: 500
  }), [u, l] = T(!1);
  return /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
    !1,
    /* @__PURE__ */ n.jsxs(ue, { titleTemplate: r == null ? void 0 : r.title, children: [
      (r == null ? void 0 : r.description) && /* @__PURE__ */ n.jsx("meta", { name: "description", content: r.description }),
      (r == null ? void 0 : r.favicon) && /* @__PURE__ */ n.jsx("link", { rel: "icon", href: r.favicon })
    ] }),
    /* @__PURE__ */ n.jsx(M, { name: "layout-before-head" }),
    /* @__PURE__ */ n.jsx(ot, {}),
    /* @__PURE__ */ n.jsx(M, { name: "layout-after-head" }),
    /* @__PURE__ */ n.jsx("div", { className: "w-full max-w-screen-2xl mx-auto px-4 lg:px-12 border-l border-r", children: d ? /* @__PURE__ */ n.jsx(qe, {}) : /* @__PURE__ */ n.jsx(pe, { fallback: /* @__PURE__ */ n.jsx(qe, {}), children: /* @__PURE__ */ n.jsxs(
      Xe,
      {
        direction: "left",
        open: u,
        onOpenChange: (f) => l(f),
        children: [
          /* @__PURE__ */ n.jsx(Ws, { onRequestClose: () => l(!1) }),
          /* @__PURE__ */ n.jsx(
            "div",
            {
              className: O(
                "lg:hidden -mx-10 px-10 py-2 sticky bg-background/80 backdrop-blur z-10 top-0 left-0 right-0 border-b",
                "peer-data-[navigation=false]:hidden"
              ),
              children: /* @__PURE__ */ n.jsxs(Ye, { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ n.jsx(Xt, { size: 16, strokeWidth: 1.5 }),
                /* @__PURE__ */ n.jsx("span", { className: "text-sm", children: "Menu" })
              ] })
            }
          ),
          /* @__PURE__ */ n.jsxs(
            "main",
            {
              className: O(
                "h-full dark:border-white/10 translate-x-0",
                "lg:overflow-visible",
                // This works in tandem with the `SidebarWrapper` component
                "lg:peer-data-[navigation=true]:w-[calc(100%-var(--side-nav-width))]",
                "lg:peer-data-[navigation=true]:translate-x-[--side-nav-width] lg:peer-data-[navigation=true]:pl-12"
              ),
              children: [
                /* @__PURE__ */ n.jsx(M, { name: "zudoku-before-content" }),
                e ?? /* @__PURE__ */ n.jsx(He, {}),
                /* @__PURE__ */ n.jsx(M, { name: "zudoku-after-content" })
              ]
            }
          )
        ]
      }
    ) }) })
  ] });
}, Xs = _e(null), oe = {
  didCatch: !1,
  error: null
};
class Ys extends Bt {
  constructor(t) {
    super(t), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = oe;
  }
  static getDerivedStateFromError(t) {
    return {
      didCatch: !0,
      error: t
    };
  }
  resetErrorBoundary() {
    const {
      error: t
    } = this.state;
    if (t !== null) {
      for (var s, r, a = arguments.length, i = new Array(a), o = 0; o < a; o++)
        i[o] = arguments[o];
      (s = (r = this.props).onReset) === null || s === void 0 || s.call(r, {
        args: i,
        reason: "imperative-api"
      }), this.setState(oe);
    }
  }
  componentDidCatch(t, s) {
    var r, a;
    (r = (a = this.props).onError) === null || r === void 0 || r.call(a, t, s);
  }
  componentDidUpdate(t, s) {
    const {
      didCatch: r
    } = this.state, {
      resetKeys: a
    } = this.props;
    if (r && s.error !== null && Js(t.resetKeys, a)) {
      var i, o;
      (i = (o = this.props).onReset) === null || i === void 0 || i.call(o, {
        next: a,
        prev: t.resetKeys,
        reason: "keys"
      }), this.setState(oe);
    }
  }
  render() {
    const {
      children: t,
      fallbackRender: s,
      FallbackComponent: r,
      fallback: a
    } = this.props, {
      didCatch: i,
      error: o
    } = this.state;
    let d = t;
    if (i) {
      const u = {
        error: o,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof s == "function")
        d = s(u);
      else if (r)
        d = Oe(r, u);
      else if (a !== void 0)
        d = a;
      else
        throw o;
    }
    return Oe(Xs.Provider, {
      value: {
        didCatch: i,
        error: o,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, d);
  }
}
function Js() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return e.length !== t.length || e.some((s, r) => !Object.is(s, t[r]));
}
class Gs {
  constructor(t) {
    k(this, "plugins");
    k(this, "sidebars");
    k(this, "topNavigation");
    k(this, "meta");
    k(this, "page");
    k(this, "authentication");
    k(this, "navigationPlugins");
    k(this, "initialize", async () => {
      await Promise.all(
        this.plugins.filter(Hs).map((t) => {
          var s;
          return (s = t.initialize) == null ? void 0 : s.call(t, this);
        })
      );
    });
    k(this, "getApiIdentities", async () => (await Promise.all(
      this.plugins.filter($s).map((s) => s.getIdentities(this))
    )).flat());
    k(this, "getPluginSidebar", async (t) => (await Promise.all(
      this.navigationPlugins.map(
        (r) => {
          var a;
          return (a = r.getSidebar) == null ? void 0 : a.call(r, W(t));
        }
      )
    )).flatMap((r) => r ?? []));
    k(this, "signRequest", async (t) => {
      if (!this.authentication)
        throw new Error("No authentication provider configured");
      const s = await this.authentication.getAccessToken();
      return t.headers.set("Authorization", `Bearer ${s}`), t;
    });
    this.plugins = t.plugins ?? [], this.topNavigation = t.topNavigation ?? [], this.sidebars = t.sidebars ?? {}, this.navigationPlugins = this.plugins.filter(Bs), this.authentication = t.authentication, this.meta = t.metadata, this.page = t.page;
  }
}
function en({ error: e, resetErrorBoundary: t }) {
  return /* @__PURE__ */ n.jsx(Le, { error: e });
}
const ee = globalThis;
(!ee.requestIdleCallback || !ee.cancelIdleCallback) && (ee.requestIdleCallback = (e) => setTimeout(e, 1), ee.cancelIdleCallback = clearTimeout);
const ct = {
  Header: ot
}, tn = _e(ct), sn = tn.Provider, nn = ({
  children: e,
  context: t
}) => (Qt({
  queryFn: async () => (await t.initialize(), !0),
  queryKey: ["zudoku-initialize"]
}), /* @__PURE__ */ n.jsx(Tt.Provider, { value: t, children: e })), dt = We(
  ({ children: e, ...t }) => {
    var g, h;
    const s = ne(
      () => ({ ...ct, ...t.overrides }),
      [t.overrides]
    ), r = ne(() => {
      var x;
      return {
        ...(t.plugins ?? []).filter(Ks).flatMap(
          (m) => m.getMdxComponents ? [m.getMdxComponents()] : []
        ).reduce(
          (m, C) => ({ ...m, ...C }),
          {}
        ),
        ...Yt,
        ...(x = t.mdx) == null ? void 0 : x.components
      };
    }, [(g = t.mdx) == null ? void 0 : g.components, t.plugins]), { stagger: a } = zt(le), [i, o] = T(!1), d = ne(
      () => i ? { stagger: !0 } : { stagger: a },
      [a, i]
    ), u = fe();
    R(() => {
      i || o(!0);
    }, [i, u.location]);
    const [l] = T(() => new Gs(t)), f = (h = t.plugins) == null ? void 0 : h.filter(Ls).map((p, x) => {
      var m;
      return /* @__PURE__ */ n.jsx(Ht, { children: (m = p.getHead) == null ? void 0 : m.call(p) }, x);
    });
    return /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
      /* @__PURE__ */ n.jsx(ue, { children: f }),
      /* @__PURE__ */ n.jsx(le.Provider, { value: d, children: /* @__PURE__ */ n.jsx(nn, { context: l, children: /* @__PURE__ */ n.jsx(ns, { components: r, children: /* @__PURE__ */ n.jsx(ms, { attribute: "class", disableTransitionOnChange: !0, children: /* @__PURE__ */ n.jsx(sn, { value: s, children: /* @__PURE__ */ n.jsx(vt, { slotlets: t.slotlets, children: /* @__PURE__ */ n.jsx(Jt, { children: e ?? /* @__PURE__ */ n.jsx(He, {}) }) }) }) }) }) }) })
    ] });
  }
);
dt.displayName = "ZudokoInner";
const ut = (e) => /* @__PURE__ */ n.jsx(Ys, { FallbackComponent: en, children: /* @__PURE__ */ n.jsx(dt, { ...e }) });
ut.displayName = "Zudoku";
const On = rs, Dn = _s, An = jt, En = ks, In = Ps, Qn = Ss, Tn = ue, qn = q, Rn = V, Fn = ut, Bn = kt, zn = Gt, Hn = et, Ln = xe, Kn = wt, $n = ge;
export {
  In as Bootstrap,
  Qn as BootstrapStatic,
  Kn as Button,
  Bn as Callout,
  Ln as ClientOnly,
  Tn as Head,
  Dn as Layout,
  $n as Link,
  zn as Markdown,
  An as RouterError,
  En as ServerError,
  Hn as Spinner,
  Fn as Zudoku,
  Rn as useAuth,
  On as useMDXComponents,
  qn as useZudoku
};
//# sourceMappingURL=zudoku.components.js.map
